import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bus_74525326 from 'nuxt_plugin_bus_74525326' // Source: ../plugins/bus.js (mode: 'all')
import nuxt_plugin_plugin_1ceef362 from 'nuxt_plugin_plugin_1ceef362' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_1ebe693c from 'nuxt_plugin_sentryserver_1ebe693c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_8df61098 from 'nuxt_plugin_sentryclient_8df61098' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_toast_30cc23b2 from 'nuxt_plugin_toast_30cc23b2' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_plugin_80adb196 from 'nuxt_plugin_plugin_80adb196' // Source: ./xhr-cache/plugin.js (mode: 'all')
import nuxt_plugin_axios_1b69a178 from 'nuxt_plugin_axios_1b69a178' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_plugin_a5d24a06 from 'nuxt_plugin_plugin_a5d24a06' // Source: ./matomo/plugin.js (mode: 'client')
import nuxt_plugin_plugin_899b0744 from 'nuxt_plugin_plugin_899b0744' // Source: ./posthog/plugin.js (mode: 'client')
import nuxt_plugin_plugin_4702dd0b from 'nuxt_plugin_plugin_4702dd0b' // Source: ./ccm/plugin.js (mode: 'client')
import nuxt_plugin_vuescrollto_36c164de from 'nuxt_plugin_vuescrollto_36c164de' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_datefns_0e6b8554 from 'nuxt_plugin_datefns_0e6b8554' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_42a15120 from 'nuxt_plugin_cookieuniversalnuxt_42a15120' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_idleevent_12398f40 from 'nuxt_plugin_idleevent_12398f40' // Source: ../plugins/idle-event.js (mode: 'client')
import nuxt_plugin_logger_057b83b1 from 'nuxt_plugin_logger_057b83b1' // Source: ../plugins/logger.js (mode: 'all')
import nuxt_plugin_fonts_08ef92e9 from 'nuxt_plugin_fonts_08ef92e9' // Source: ../plugins/fonts.js (mode: 'client')
import nuxt_plugin_metaoptions_22a6e12b from 'nuxt_plugin_metaoptions_22a6e12b' // Source: ../plugins/meta-options.js (mode: 'client')
import nuxt_plugin_vuexcache_d315c98c from 'nuxt_plugin_vuexcache_d315c98c' // Source: ../plugins/vuex-cache.js (mode: 'client')
import nuxt_plugin_helper_850e665a from 'nuxt_plugin_helper_850e665a' // Source: ../plugins/helper.js (mode: 'all')
import nuxt_plugin_head_1635d3e1 from 'nuxt_plugin_head_1635d3e1' // Source: ../plugins/head.js (mode: 'all')
import nuxt_plugin_mix_50155dde from 'nuxt_plugin_mix_50155dde' // Source: ../plugins/mix.js (mode: 'all')
import nuxt_plugin_ziggy_470965ba from 'nuxt_plugin_ziggy_470965ba' // Source: ../plugins/ziggy.js (mode: 'all')
import nuxt_plugin_vueglobalevents_5dd30a71 from 'nuxt_plugin_vueglobalevents_5dd30a71' // Source: ../plugins/vue-global-events.js (mode: 'all')
import nuxt_plugin_vuetinylazyloadbg_e6b97462 from 'nuxt_plugin_vuetinylazyloadbg_e6b97462' // Source: ../plugins/vue-tiny-lazyload-bg.js (mode: 'client')
import nuxt_plugin_vuetinylazyload_3394c7ed from 'nuxt_plugin_vuetinylazyload_3394c7ed' // Source: ../plugins/vue-tiny-lazyload.js (mode: 'client')
import nuxt_plugin_esm_7a70f1ce from 'nuxt_plugin_esm_7a70f1ce' // Source: ../node_modules/vanilla-fade/dist/esm (mode: 'client')
import nuxt_plugin_vueforcenexttick_54cd5c9f from 'nuxt_plugin_vueforcenexttick_54cd5c9f' // Source: ../plugins/vue-force-next-tick.js (mode: 'all')
import nuxt_plugin_vuevanillalazyload_483469e4 from 'nuxt_plugin_vuevanillalazyload_483469e4' // Source: ../plugins/vue-vanilla-lazyload.js (mode: 'client')
import nuxt_plugin_vueagile_6bd42cd0 from 'nuxt_plugin_vueagile_6bd42cd0' // Source: ../plugins/vue-agile.js (mode: 'client')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_echosync_622cc84a from 'nuxt_plugin_echosync_622cc84a' // Source: ../plugins/echo-sync.js (mode: 'client')
import nuxt_plugin_waiter_36174b1f from 'nuxt_plugin_waiter_36174b1f' // Source: ../plugins/waiter.js (mode: 'all')
import nuxt_plugin_vueobservevisibility_66676af7 from 'nuxt_plugin_vueobservevisibility_66676af7' // Source: ../plugins/vue-observe-visibility.js (mode: 'all')
import nuxt_plugin_loader_7a10d364 from 'nuxt_plugin_loader_7a10d364' // Source: ../plugins/loader.js (mode: 'client')
import nuxt_plugin_toast_bdf93834 from 'nuxt_plugin_toast_bdf93834' // Source: ../plugins/toast.js (mode: 'client')
import nuxt_plugin_states_18eb0402 from 'nuxt_plugin_states_18eb0402' // Source: ../plugins/states.js (mode: 'all')
import nuxt_plugin_tracking_31194aaa from 'nuxt_plugin_tracking_31194aaa' // Source: ../plugins/tracking.js (mode: 'client')
import nuxt_plugin_vueappend_f2fbe540 from 'nuxt_plugin_vueappend_f2fbe540' // Source: ../plugins/vue-append.js (mode: 'client')
import nuxt_plugin_googleapi_dcea600a from 'nuxt_plugin_googleapi_dcea600a' // Source: ../plugins/google-api.js (mode: 'client')
import nuxt_plugin_tagmanager_07788c33 from 'nuxt_plugin_tagmanager_07788c33' // Source: ../plugins/tag-manager.js (mode: 'client')
import nuxt_plugin_jsonld_2ff766e1 from 'nuxt_plugin_jsonld_2ff766e1' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_ping_7618c1e2 from 'nuxt_plugin_ping_7618c1e2' // Source: ../plugins/ping.js (mode: 'client')
import nuxt_plugin_xhrcache_397e6396 from 'nuxt_plugin_xhrcache_397e6396' // Source: ../plugins/xhr-cache.js (mode: 'all')
import nuxt_plugin_auth_bcf80e90 from 'nuxt_plugin_auth_bcf80e90' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_sentrylazy_2d2079ea from 'nuxt_plugin_sentrylazy_2d2079ea' // Source: ../plugins/sentry-lazy.js (mode: 'client')
import nuxt_plugin_echo_55bfbf1b from 'nuxt_plugin_echo_55bfbf1b' // Source: ./echo.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"EVINTRA","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Your worldwide comprehensive mice &amp; tourism directory"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fwww.evintra.com"},{"hid":"twitter:title","name":"twitter:title","content":"EVENT &bull; INCENTIVE &bull; TRAVEL | EVINTRA"},{"hid":"twitter:description","name":"twitter:description","content":"Your worldwide comprehensive mice &amp; tourism directory"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fd3q0rjg0segfeu.cloudfront.net\u002Fimages\u002Fsocial-share.jpg"},{"hid":"twitter:image:alt","name":"twitter:image:alt","content":"EVENT &bull; INCENTIVE &bull; TRAVEL | EVINTRA"},{"hid":"og:site_name","property":"og:site_name","content":"EVINTRA"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.evintra.com"},{"hid":"og:title","property":"og:title","content":"EVENT &bull; INCENTIVE &bull; TRAVEL | EVINTRA"},{"hid":"og:description","property":"og:description","content":"Your worldwide comprehensive mice &amp; tourism directory"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fd3q0rjg0segfeu.cloudfront.net\u002Fimages\u002Fsocial-share.jpg"},{"hid":"og:image:secure_url","property":"og:image:secure_url","content":"https:\u002F\u002Fd3q0rjg0segfeu.cloudfront.net\u002Fimages\u002Fsocial-share.jpg"},{"hid":"og:image:alt","property":"og:image:alt","content":"EVENT &bull; INCENTIVE &bull; TRAVEL | EVINTRA"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fd3q0rjg0segfeu.cloudfront.net\u002Ffavicon.ico"},{"rel":"preload","type":"font\u002Fwoff2","as":"font","href":"https:\u002F\u002Fd3q0rjg0segfeu.cloudfront.net\u002Ffonts\u002Flato\u002Flato-v17-latin-ext_latin-regular.woff2","crossorigin":""},{"rel":"preload","type":"font\u002Fwoff2","as":"font","href":"https:\u002F\u002Fd3q0rjg0segfeu.cloudfront.net\u002Ffonts\u002Flato\u002Flato-v17-latin-ext_latin-700.woff2","crossorigin":""},{"rel":"preload","type":"font\u002Fwoff2","as":"font","href":"https:\u002F\u002Fd3q0rjg0segfeu.cloudfront.net\u002Ffonts\u002Flato\u002Flato-v17-latin-ext_latin-300.woff2","crossorigin":""},{"rel":"preload","type":"font\u002Fwoff2","as":"font","href":"https:\u002F\u002Fd3q0rjg0segfeu.cloudfront.net\u002Ffonts\u002Flato\u002Flato-v17-latin-ext_latin-900.woff2","crossorigin":""}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bus_74525326 === 'function') {
    await nuxt_plugin_bus_74525326(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_1ceef362 === 'function') {
    await nuxt_plugin_plugin_1ceef362(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_1ebe693c === 'function') {
    await nuxt_plugin_sentryserver_1ebe693c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_8df61098 === 'function') {
    await nuxt_plugin_sentryclient_8df61098(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_30cc23b2 === 'function') {
    await nuxt_plugin_toast_30cc23b2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_80adb196 === 'function') {
    await nuxt_plugin_plugin_80adb196(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_1b69a178 === 'function') {
    await nuxt_plugin_axios_1b69a178(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin_a5d24a06 === 'function') {
    await nuxt_plugin_plugin_a5d24a06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin_899b0744 === 'function') {
    await nuxt_plugin_plugin_899b0744(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin_4702dd0b === 'function') {
    await nuxt_plugin_plugin_4702dd0b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_36c164de === 'function') {
    await nuxt_plugin_vuescrollto_36c164de(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_0e6b8554 === 'function') {
    await nuxt_plugin_datefns_0e6b8554(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_42a15120 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_42a15120(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_idleevent_12398f40 === 'function') {
    await nuxt_plugin_idleevent_12398f40(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_057b83b1 === 'function') {
    await nuxt_plugin_logger_057b83b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fonts_08ef92e9 === 'function') {
    await nuxt_plugin_fonts_08ef92e9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_metaoptions_22a6e12b === 'function') {
    await nuxt_plugin_metaoptions_22a6e12b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexcache_d315c98c === 'function') {
    await nuxt_plugin_vuexcache_d315c98c(app.context, inject)
  }

  if (typeof nuxt_plugin_helper_850e665a === 'function') {
    await nuxt_plugin_helper_850e665a(app.context, inject)
  }

  if (typeof nuxt_plugin_head_1635d3e1 === 'function') {
    await nuxt_plugin_head_1635d3e1(app.context, inject)
  }

  if (typeof nuxt_plugin_mix_50155dde === 'function') {
    await nuxt_plugin_mix_50155dde(app.context, inject)
  }

  if (typeof nuxt_plugin_ziggy_470965ba === 'function') {
    await nuxt_plugin_ziggy_470965ba(app.context, inject)
  }

  if (typeof nuxt_plugin_vueglobalevents_5dd30a71 === 'function') {
    await nuxt_plugin_vueglobalevents_5dd30a71(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetinylazyloadbg_e6b97462 === 'function') {
    await nuxt_plugin_vuetinylazyloadbg_e6b97462(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetinylazyload_3394c7ed === 'function') {
    await nuxt_plugin_vuetinylazyload_3394c7ed(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_esm_7a70f1ce === 'function') {
    await nuxt_plugin_esm_7a70f1ce(app.context, inject)
  }

  if (typeof nuxt_plugin_vueforcenexttick_54cd5c9f === 'function') {
    await nuxt_plugin_vueforcenexttick_54cd5c9f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuevanillalazyload_483469e4 === 'function') {
    await nuxt_plugin_vuevanillalazyload_483469e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueagile_6bd42cd0 === 'function') {
    await nuxt_plugin_vueagile_6bd42cd0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_echosync_622cc84a === 'function') {
    await nuxt_plugin_echosync_622cc84a(app.context, inject)
  }

  if (typeof nuxt_plugin_waiter_36174b1f === 'function') {
    await nuxt_plugin_waiter_36174b1f(app.context, inject)
  }

  if (typeof nuxt_plugin_vueobservevisibility_66676af7 === 'function') {
    await nuxt_plugin_vueobservevisibility_66676af7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_loader_7a10d364 === 'function') {
    await nuxt_plugin_loader_7a10d364(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_bdf93834 === 'function') {
    await nuxt_plugin_toast_bdf93834(app.context, inject)
  }

  if (typeof nuxt_plugin_states_18eb0402 === 'function') {
    await nuxt_plugin_states_18eb0402(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tracking_31194aaa === 'function') {
    await nuxt_plugin_tracking_31194aaa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueappend_f2fbe540 === 'function') {
    await nuxt_plugin_vueappend_f2fbe540(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleapi_dcea600a === 'function') {
    await nuxt_plugin_googleapi_dcea600a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tagmanager_07788c33 === 'function') {
    await nuxt_plugin_tagmanager_07788c33(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff766e1 === 'function') {
    await nuxt_plugin_jsonld_2ff766e1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ping_7618c1e2 === 'function') {
    await nuxt_plugin_ping_7618c1e2(app.context, inject)
  }

  if (typeof nuxt_plugin_xhrcache_397e6396 === 'function') {
    await nuxt_plugin_xhrcache_397e6396(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_bcf80e90 === 'function') {
    await nuxt_plugin_auth_bcf80e90(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentrylazy_2d2079ea === 'function') {
    await nuxt_plugin_sentrylazy_2d2079ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_echo_55bfbf1b === 'function') {
    await nuxt_plugin_echo_55bfbf1b(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
